import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router"
import { UserService } from "../services/user.service"
import Utils from "../utils/utils"
import { StudentGateService } from "../services/student-gate.service"

@Injectable()
export class StudentGateSearchGuard implements CanActivate {
    constructor(
        private userService: UserService,
        private router: Router,
        private studentGateService: StudentGateService
    ) {}
    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const selectedGrade = sessionStorage.getItem("grade-gate")
        if (!Utils.hasStudentExperience()) return true
        //if the grade is5orSmaller the excluded facet param will persist
        // and this is entering an infinite loop from home page -> search page
        // and the next line index var is the solution
        let index = Utils.is5thGradeOrSmaller() ? 3 : 2
        const queryParams = this.buildQueryParams(route)
        if (selectedGrade?.length && Object.values(route.queryParams)?.length <= index) {
            this.router.navigate(["/search/"], {
                queryParams: queryParams,
                queryParamsHandling: "merge",
            })
            return false
        } else if (this.isDisplayModalRequired(selectedGrade, route)) {
            this.studentGateService.openStudentGateModal()
            return false
        } else {
            return true
        }
    }

    public buildQueryParams(route) {
        const selectedGrade = sessionStorage.getItem("grade-gate")
        const avoidSettingGradeBand = !!sessionStorage.getItem("avoid-setting-grade-band")

        let queryParams = {
            ...route.queryParams,
            q: route.queryParams.q ? route.queryParams.q : "",
            student: true,
            excluded_facet: Utils.is5thGradeOrSmaller() ? "media_type:Collection" : null,
            selected_facet: route.queryParams.selected_facet,
        }
        if (!avoidSettingGradeBand) {
            queryParams = {
                ...queryParams,
                selected_facet: route.queryParams.selected_facet
                    ? [route.queryParams.selected_facet, "grades:" + selectedGrade]
                    : "grades:" + selectedGrade,
            }
        }

        sessionStorage.removeItem("avoid-setting-grade-band")
        return queryParams
    }

    public isDisplayModalRequired(
        selectedGrade: string | null,
        nextRoute: ActivatedRouteSnapshot
    ): boolean {
        return (
            !selectedGrade &&
            !this.studentGateService.isLgModalDisplayed &&
            (this.studentGateService.isEmptySearch(nextRoute.queryParams) ||
                this.router.getCurrentNavigation().id > 1)
        )
    }
}
